import React, { useEffect, useState } from 'react'

import { Btn, CustomModal, InputNumeroInteiro } from '../../../../components'
import * as EmissoresHttp from '../../../../services/api/https/settings/emissor-cte.http'
import { errorHandler } from '../../../../services/util/error.service'

const TEMPO_LIMITE_ULT_EMITIDO = 30

export default function ModalUltimoEmitido({ emissor, isVisible, onClose, onSuccess, onError }) {
  // Hooks
  const [valor, setValor] = useState('')
  const [segundos, setSegundos] = useState(TEMPO_LIMITE_ULT_EMITIDO)
  const [salvando, setSalvando] = useState(false)

  useEffect(() => {
    if (!isVisible) return

    setValor(emissor.cte_ultimo_emitido === null ? '' : emissor.cte_ultimo_emitido)
    setSegundos(TEMPO_LIMITE_ULT_EMITIDO)
    setSalvando(false)

    const intervalo = setInterval(() => {
      setSegundos(s => Math.max(s - 1, 0))
    }, 1000)

    return () => clearInterval(intervalo)
  }, [isVisible])

  // Tempo esgotado: fecha sem persistir a alteração
  useEffect(() => {
    if (isVisible && segundos <= 0 && !salvando) {
      onError('Tempo esgotado. A alteração não foi salva.')
      onClose()
    }
  }, [segundos, salvando])

  // Events
  const onBtnSalvarClicked = async () => {
    if (salvando || segundos <= 0) return

    try {
      if (!/^\d+$/.test(String(valor)))
        throw new Error('Informe um número inteiro maior ou igual a 0')

      setSalvando(true)
      const emissorAtualizado = await EmissoresHttp.updateUltimoEmitido(emissor.id, Number(valor))
      onSuccess(emissorAtualizado)
    } catch (error) {
      onError(errorHandler(error))
    } finally {
      setSalvando(false)
    }
  }

  const semAlteracao = String(valor) === String(emissor.cte_ultimo_emitido)

  // Render
  return (
    <CustomModal
      width={400}
      header="Alterar Cte Últ. Emitido"
      isVisible={isVisible}
      onClose={onClose}
    >
      <InputNumeroInteiro
        label="Cte Últ. Emitido:*"
        marginTop={0}
        value={valor}
        onChange={setValor}
        allowNegative={false}
        decimalScale={0}
        isAllowed={({ value }) => value.length <= 9}
      />
      <p style={{ marginTop: 10, color: segundos <= 10 ? '#d9534f' : undefined }}>
        Tempo restante: {segundos}s
      </p>
      <div style={{ display: 'flex', gap: 5, marginTop: 10 }}>
        <Btn
          onClick={onBtnSalvarClicked}
          isLoading={salvando}
          disabled={segundos <= 0 || semAlteracao}
        >
          Salvar
        </Btn>
        <Btn onClick={onClose} backgroundColor="#999">
          Cancelar
        </Btn>
      </div>
    </CustomModal>
  )
}
